import React, { useEffect, useState } from 'react'
import { ParentLayout } from '../../../layout/parentLayout';
import NewSideBarParent from '../../../components/NewSideBarParent';
import { RecommendedClasses } from '../../../components/RecommendedClasses';
import Chatbar from '../../../components/Chatbar';
import { Button, Checkbox, FormControlLabel, Input, InputAdornment, MenuItem, Select, styled, Switch, SwitchProps, TextField, Typography } from '@mui/material';
import { TabCard } from '../../../components/TabCard';
import { CLASS_SETTING } from '../../../constants/enums';
import NewSideBarTutor from '../../../components/NewSideBarTutor';
import { TutorLayout } from '../../../layout/tutorLayout';
import { useNavigate } from 'react-router-dom';
import { useGetClassesForTutorQuery } from '../../../service/class';

function TutorClasses() {
    const { data: classData } = useGetClassesForTutorQuery({ setting: CLASS_SETTING.PUBLISH, limit: 20, page: 1 });
    const navigate = useNavigate();



    const IOSSwitch = styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    }));


    return (
        <>
            <TutorLayout className="role-layout">
                <main className="content">
                    <section className="uh_spc pSearchResult_sc home_wrp">
                        <div className="conta_iner v2">
                            <div className="mn_fdx">
                                <NewSideBarTutor />
                                <div className="mdl_cntnt ">
                                    {/* <div className='swtch_bar'>
                                        <p>Switch to Private</p>
                                        <FormControlLabel
                                            control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                                            label=""
                                        />

                                    </div> */}
                                    <ul className='cstmm_tabs'>
                                        <TabCard name='Public Class' isActive={true} />
                                        <TabCard name='Private Class' isActive={false} />
                                    </ul>

                                    <div className='gap_m rec_clsss'>
                                        {classData?.data?.data?.length ? classData?.data?.data?.map((item: any) => {
                                            return (
                                              <RecommendedClasses data={item} />
                                            )
                                        }) : null}
                                    </div>
                                </div>
                                <div className="sidebar_rt">
                                    <button onClick={() => navigate("/tutor/create-class")} className='btn transparent' >Create class</button>
                                    <section className="side_menu_wrap unlock_bg ">
                                        <div className="group">
                                            <h4>Unlock Learning, Book Your Perfect Tutor Today!</h4>
                                            <button>Book Now</button>
                                        </div>
                                        <figure>
                                            <img src={`/static/images/unlock_men.png`} alt="unlock_men" />
                                        </figure>
                                    </section>
                                    <section className="side_menu_wrap  page_link">
                                        <ul>
                                            <li>
                                                <a>About Us</a>
                                            </li>
                                            <li>
                                                <a>Contact Us</a>
                                            </li>
                                            <li>
                                                <a>Help Center</a>
                                            </li>
                                            <li>
                                                <a>Terms & conditions</a>
                                            </li>
                                            <li>
                                                <a>Privacy Policy</a>
                                            </li>
                                            <li>
                                                <a>FAQ’s</a>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                            </div>

                        </div>
                    </section>
                </main>


            </TutorLayout>
        </>
    );
}

export default TutorClasses;